<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="submitCallback"

    @cancel="handleCancel"
    cancelText="关闭">
    <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-radio-group v-model="model.pmtFlg">
        <a-row :gutter="24" >
          <a-form-item>
<!--            <a-radio value="1" style="display: none;">永久有效</a-radio>-->
          </a-form-item>
        </a-row>
        <a-row :gutter="24">

            <a-radio value="0">
              <a-form-item class="cart-time-item">
                购买后
                <a-input-number
                  v-decorator="['validityNumber',{rules: [
                        {
                          required: (this.model.pmtFlg == 0),
                          message: '请输入有效时间'
                        }
                      ]}]"
                  :min="1"
                ></a-input-number>
                </a-form-item>
              <a-form-item class="cart-time-item">
                <a-select class="cart-time-select" placeholder="请选择单位" v-decorator="['timeUnit',{rules: [
                      {
                        required: (this.model.pmtFlg == 0),
                        message: '请选择单位'
                      }
                    ]}]">
                  <a-select-option v-for="item in timeUnitOptions" :key="item.value" :value="item.value">{{item.text}}</a-select-option>
                </a-select>
                有效
              </a-form-item>
            </a-radio>

        </a-row>
      </a-radio-group>
    </a-form>
  </j-modal>
</template>

<script>

  export default {
    name: 'CardTimeModal',
    components: {
    },
    props: ['timeUnitOptions'],
    data () {
      return {
        title:'',
        form: this.$form.createForm(this), //form对象
        width:350,
        visible: false,
        disableSubmit: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        model:{
          pmtFlg:"0",
          timeUnit:2,
          validityNumber:1,
        }
      }
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(() => {
          this.form.setFieldsValue({
            validityNumber:this.modelDefault.validityNumber,
            timeUnit:this.modelDefault.timeUnit,
          });
        });
      },
      edit (record) {
        this.visible=true
        this.model = Object.assign({},this.model, record)
        this.$nextTick(()=>{
          let values = {"validityNumber":this.model.validityNumber};
          values.timeUnit = (values.timeUnit==undefined?2:values.timeUnit)+'';
          this.form.setFieldsValue(values);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      submitCallback(){
        this.form.validateFields((err, values) => {
          if(!err){
            let formData = Object.assign({},this.model, values);
            this.$emit('ok',formData);
            this.visible = false;
          }
        });
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style lang="less" scoped>
  .cart-time-item{
    display: inline-block;
    top: -8px;
  }
  .cart-time-select{
    margin-left:10px;
    width: 80px
  }
</style>